import { render, staticRenderFns } from "./FilterChat.vue?vue&type=template&id=869a3b4e&"
import script from "./FilterChat.vue?vue&type=script&lang=js&"
export * from "./FilterChat.vue?vue&type=script&lang=js&"
import style0 from "./FilterChat.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports